import * as d3 from 'd3-zoom'

export default {
  data () {
    return {
      zoomState: {
        transform: d3.zoomIdentity,
        center: [this.width / 2, this.height / 2]
      }
    }
  },
  computed: {
    zoomTransform () {
      return this.zoomState.transform.toString()
    }
  },
  mounted () {    
    this.$refs.svg.addEventListener('wheel', evt => {
      this.zoomScale(evt.deltaY > 0 ? 0.8 : 1.25)
    })
    this.$refs.svg.addEventListener('mousedown', evt => {
      this.zoomState.dragX = evt.clientX
      this.zoomState.dragY = evt.clientY
      window.addEventListener('mousemove', this.zoomDrag)
      window.addEventListener('mouseup', this.zoomDragEnd)
    })
  },
  methods: {
    zoomSet (zoom) {
      this.zoomState.transform = d3.zoomIdentity
        .translate(zoom.transform.x, zoom.transform.y)
        .scale(zoom.transform.k)
      this.zoomState.center = zoom.center
    },
    zoomScale (k) {
      this.zoomState.transform = this.zoomState.transform.scale(k)
      const center = this.zoomState.transform.invert(this.zoomState.center)
      this.zoomState.transform = this.zoomState.transform.translate(
        center[0] - this.width / 2,
        center[1] - this.height / 2
      )
    },
    zoomTranslate (x, y) {
      this.zoomState.transform = d3.zoomIdentity
        .translate(x, y)
        .translate(this.zoomState.transform.x, this.zoomState.transform.y)
        .scale(this.zoomState.transform.k)
      this.zoomState.center = [this.zoomState.center[0] + x, this.zoomState.center[1] + y]
    },
    zoomReset () {
      this.zoomState.transform = d3.zoomIdentity
      this.zoomState.center = [this.width / 2, this.height / 2]
    },
    zoomDrag (evt) {
      this.zoomTranslate(evt.clientX - this.zoomState.dragX, evt.clientY - this.zoomState.dragY)
      this.zoomState.dragX = evt.clientX
      this.zoomState.dragY = evt.clientY
    },
    zoomDragEnd () {
      window.removeEventListener('mousemove', this.zoomDrag)
      window.removeEventListener('mouseup', this.zoomDragEnd)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/d3vue/mixins/zoom.js